import type { RouteRecordRaw } from 'vue-router';
import { SharedRoutes } from '@/types/enums/RouteNameEnums';
import { FeatureKeyEnum } from '@/types/enums/FeatureKeyEnum';
import { NavigationKeyEnum } from '@/types/enums/NavigationKeyEnum';

export const sharedRoutes: RouteRecordRaw[] = [
    {
        name: SharedRoutes.Home,
        path: '/',
        component: () => import('@/views/DynamicHome.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'dashboard',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.Home,
            skipFeatureCheck: true,
        },
    },
    {
        name: SharedRoutes.Users,
        path: '/users',
        component: () => import('@/views/DynamicUsers.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'users',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.Users,
        },
    },
    {
        name: SharedRoutes.UsersCreate,
        path: '/users/create',
        component: () => import('@/views/DynamicUsers.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'users',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.Users,
        },
    },
    {
        name: SharedRoutes.UsersEdit,
        path: '/users/:id',
        component: () => import('@/views/DynamicUsers.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'users',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.Users,
        },
    },
    {
        name: SharedRoutes.Profile,
        path: '/profile',
        component: () => import('@/views/DynamicProfile.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'profile',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.Profile,
        },
    },
    {
        name: SharedRoutes.AntennaMonitoring,
        path: '/antenna-monitoring',
        component: () => import('@/views/DynamicAntennaMonitoring.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'antennaMonitoring',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.AntennaMonitoring,
            featureKey: FeatureKeyEnum.AntennaMonitoring,
        },
    },
    {
        name: SharedRoutes.LogsHooks,
        path: '/logs/hooks',
        component: () => import('@/views/logs/Hooks.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'hookLogs',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.LogsHooks,
            featureKey: FeatureKeyEnum.SystemLogs,
        },
    },
    {
        name: SharedRoutes.LogsExternalApi,
        path: '/logs/external-api',
        component: () => import('@/views/logs/ExternalApi.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'externalApiLogs',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.ExternalApiLogs,
            featureKey: FeatureKeyEnum.SystemLogs,
        },
    },
    {
        name: SharedRoutes.LogsAntennaStats,
        path: '/logs/antenna-stats',
        component: () => import('@/views/logs/AntennaStats.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'antennaStatsLogs',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.LogsAntennaStats,
            featureKey: FeatureKeyEnum.SystemLogs,
        },
    },
    {
        name: SharedRoutes.LogsEpcReadings,
        path: '/logs/epc-readings',
        component: () => import('@/views/logs/EpcReadings.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'epcReadingLogs',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.LogsEpcReading,
            featureKey: FeatureKeyEnum.SystemLogs,
        },
    },
    {
        name: SharedRoutes.LogsWarehouseNodeEpc,
        path: '/logs/warehouse-node-epc',
        component: () => import('@/views/logs/WarehouseNodeEpc.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'warehouseNodeEpcLogs',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.LogsWarehouseNodeEpc,
            featureKey: FeatureKeyEnum.SystemLogs,
        },
    },
    {
        name: SharedRoutes.EanRegistry,
        path: '/ean-registry',
        component: () => import('@/views/DynamicEanRegistry.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'eanRegistry',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.EanRegistry,
            featureKey: FeatureKeyEnum.EanRegistry,
        },
    },
    {
        name: SharedRoutes.EanRegistryCreate,
        path: '/ean-registry/create',
        component: () => import('@/views/DynamicEanRegistry.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'eanRegistry',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.EanRegistry,
            featureKey: FeatureKeyEnum.EanRegistry,
        },
    },
    {
        name: SharedRoutes.EanRegistryEdit,
        path: '/ean-registry/:id',
        component: () => import('@/views/DynamicEanRegistry.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'eanRegistry',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.EanRegistry,
            featureKey: FeatureKeyEnum.EanRegistry,
        },
    },
    {
        name: SharedRoutes.CashRegisters,
        path: '/cash-registers',
        component: () => import('@/views/DynamicCashRegisters.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'cashRegisters',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CashRegisters,
            featureKey: FeatureKeyEnum.CashRegisters,
        },
    },
    {
        name: SharedRoutes.CashRegistersCreate,
        path: '/cash-registers/create',
        component: () => import('@/views/DynamicCashRegisters.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'cashRegisters',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CashRegisters,
            featureKey: FeatureKeyEnum.CashRegisters,
        },
    },
    {
        name: SharedRoutes.CashRegistersEdit,
        path: '/cash-registers/:id',
        component: () => import('@/views/DynamicCashRegisters.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'cashRegisters',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CashRegisters,
            featureKey: FeatureKeyEnum.CashRegisters,
        },
    },
    {
        name: SharedRoutes.PackingStations,
        path: '/packing-stations',
        component: () => import('@/views/DynamicPackingStations.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'packingStations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.PackingStations,
            featureKey: FeatureKeyEnum.PackingStations,
        },
    },
    {
        name: SharedRoutes.PackingStationsCreate,
        path: '/packing-stations/create',
        component: () => import('@/views/DynamicPackingStations.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'packingStations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.PackingStations,
            featureKey: FeatureKeyEnum.PackingStations,
        },
    },
    {
        name: SharedRoutes.PackingStationsEdit,
        path: '/packing-stations/:id',
        component: () => import('@/views/DynamicPackingStations.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'packingStations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.PackingStations,
            featureKey: FeatureKeyEnum.PackingStations,
        },
    },
    {
        name: SharedRoutes.PackageContents,
        path: '/package-contents/:tenantId/:packageProductId',
        component: () => import('@/views/DynamicPackageContents.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            pageTitle: 'packageContents',
            skipFeatureCheck: true,
        },
    },
];
